jQuery(function($) {

	/**
	* 記事中のiframeを強制的にdivで囲む
	*/

	$('.main .section iframe:not(".reset")').wrap('<div class="u-obj-box"></div>');

});